import { supabase } from '~/supabase-client'

/**
 * Get descendant organization IDs based on org type
 * Business logic for hierarchical organization traversal
 *
 * @param {string} orgId - Organization ID
 * @param {string} orgType - Organization type (farm, plot, patch)
 * @returns {Promise<Array<string>>} Array of descendant org IDs
 */
export async function getDescendantOrgs(orgId, orgType) {
  try {
    switch (orgType) {
      case 'farm': {
        // Get all plots + patches
        const { data: plots } = await supabase
          .from('organizations')
          .select('id')
          .eq('parent_organization_id', orgId)
          .eq('organization_type', 'plot')

        if (!plots || plots.length === 0) return []

        const plotIds = plots.map(p => p.id)

        const { data: patches } = await supabase
          .from('organizations')
          .select('id')
          .in('parent_organization_id', plotIds)
          .eq('organization_type', 'patch')

        return [...plotIds, ...(patches?.map(p => p.id) || [])]
      }

      case 'plot': {
        // Get all patches
        const { data: patches } = await supabase
          .from('organizations')
          .select('id')
          .eq('parent_organization_id', orgId)
          .eq('organization_type', 'patch')

        return patches?.map(p => p.id) || []
      }

      case 'patch':
        // No descendants for patches
        return []

      default:
        console.warn(`[TASK DATA] Unknown org type: ${orgType}`)
        return []
    }
  } catch (err) {
    console.error('[TASK DATA] Error fetching descendants:', err)
    return []
  }
}
